export default __webpack_public_path__ + "static/gajar-c8b2a0ae6422d1aa5990ffc208d726c8.png";